module.exports = __webpack_public_path__ + "static/img/icn_payment@3x.ebf29d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icn_payment@3x.png
// module id = HESY
// module chunks = 10